import type { SvgIconProps } from './icon-props';

// 16px clock drawn for small inline text (e.g. card duration). The path inherits the
// text color by default, so it follows the surrounding `text-*` token.
export default function IconTimeSmall({
	width = 16,
	height = 16,
	fill = 'currentColor',
	role,
	className,
}: SvgIconProps) {
	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 16 16"
			fill="none"
			role={role}
			className={className}
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M4.15 2.19727C5.02244 1.61383 6.01345 1.23121 7.05161 1.077C8.08977 0.922793 9.14921 1.00083 10.1536 1.30548C11.1579 1.61014 12.0822 2.13383 12.8597 2.8388C13.6373 3.54377 14.2487 4.41246 14.65 5.38227C15.008 6.24257 15.1916 7.16543 15.19 8.09727C15.1895 9.32273 14.8716 10.5272 14.2673 11.5933C13.6629 12.6594 12.7928 13.5507 11.7415 14.1806C10.6903 14.8104 9.49388 15.1572 8.26878 15.1873C7.04368 15.2173 5.83169 14.9295 4.75088 14.3519C3.67008 13.7742 2.7573 12.9265 2.10149 11.8913C1.44567 10.8561 1.06916 9.66868 1.00866 8.44471C0.948146 7.22074 1.20569 6.00196 1.75621 4.90711C2.30672 3.81225 3.13143 2.87866 4.15 2.19727ZM4.385 13.6523C5.29839 14.2614 6.34756 14.6365 7.44008 14.7446C8.5326 14.8527 9.63494 14.6905 10.65 14.2723C11.4605 13.9341 12.1975 13.4417 12.82 12.8223C13.7938 11.8486 14.4429 10.5978 14.6784 9.24098C14.9139 7.8842 14.7244 6.48779 14.1357 5.24289C13.547 3.99798 12.588 2.96543 11.3899 2.28657C10.1918 1.60772 8.81315 1.31573 7.4427 1.45058C6.07224 1.58543 4.77696 2.14053 3.73414 3.0399C2.69132 3.93926 1.95194 5.13893 1.6172 6.4747C1.28247 7.81047 1.36873 9.21705 1.86419 10.5019C2.35965 11.7867 3.2401 12.8871 4.385 13.6523ZM7.885 8.97227V4.35227H8.335V8.50227H11.925V8.95727L7.885 8.97227Z"
				fill={fill}
			/>
		</svg>
	);
}
